const prefix = 'module-sign-up__';

export const SignUpStores = Object.freeze({
    PRICING_PLAN: `${prefix}pricing-plan`, // TODO: Subject for removal, including the actual file.
    SIGN_UP: `${prefix}sign-up`,
    SERVICE: `${prefix}service`,
});
